import React from "react";
import { Col, Row, Spacer } from "@amzn/stencil-react-components/layout";
import { Label } from "@amzn/stencil-react-components/text";
import { useAppDispatch, useAppSelector } from "src/state/hooks";
import { updateEventSolutionType } from "src/state/slice/EventModelSlice";
import { Select } from "@amzn/stencil-react-components/form";
import { Text } from "@amzn/stencil-react-components/text";
import "src/components/commonStyles.scss";
import * as solutionConfig from "src/config/solutionConfigs.json";
import { SolutionDetailsRenderer } from "./SolutionDetailsRenderer";
import { IconWithTooltip } from "../helperComponents/IconWithTooltip";

const STRINGS_DISPLAYED = {
  define_solution_label: "Define solution",
  solution_type_label: "Solution type",
  solution_type_placeholder: "Choose a solution type",
  solution_details_label: "Solution details",
  edit_as_json: "Edit as JSON",
  required_string: "* indicates required",
}
interface SolutionComponentProps {
  triggersAndSolutionTypes: string[];
  actionType: string;
  disabled?: boolean;
}

/**
 * Renders the components for defining solutions for the event models.
 */
export const SolutionComponent = ({triggersAndSolutionTypes, actionType, disabled}: SolutionComponentProps) => {
  const dispatch = useAppDispatch();
  const eventModelState = useAppSelector(({eventModel}) => eventModel);
  const availableSolutions = Object.keys(solutionConfig).filter(solutionType => triggersAndSolutionTypes.includes(solutionType));

  const onSolutionTypeChange = (solutionType: string) => {
    dispatch(updateEventSolutionType(solutionType));
  }

  return <Col gridGap={"16px"}>
    <Label fontSize={"20px"} fontWeight={"bold"} htmlFor={"define-solution"}>
      {STRINGS_DISPLAYED.define_solution_label}
    </Label>

    <Row 
      alignItems={"center"} 
      justifyContent={"space-between"}
      width={"fit-content"}
      id={"define-solution"}
    >
      <Label 
        fontSize={"18px"} 
        fontWeight={"bold"} 
        htmlFor={"solution-type"}
        className={"width_200_px"}
      >
        {STRINGS_DISPLAYED.solution_type_label}
      </Label>
      <Select
        id={"solution-type"}
        options={availableSolutions}
        value={eventModelState?.eventSolution?.type}
        onChange={onSolutionTypeChange}
        width={"400px"}
        placeholder={STRINGS_DISPLAYED.solution_type_placeholder}
        disabled={disabled}
      />
      {(eventModelState?.eventSolution?.type && solutionConfig[eventModelState.eventSolution.type]?.description) &&
        <>
          <Spacer width={"4px"}/>
          <IconWithTooltip
            tooltipText={solutionConfig[eventModelState.eventSolution.type].description}
            color={"primary70"}
          />
        </>}
    </Row>

    {
      eventModelState?.eventSolution?.type &&
      <Col>
        <Row
          alignItems={"center"}
          justifyContent={"space-between"}
          width={"1000px"}
        >
          <Label fontSize={"18px"} fontWeight={"bold"} htmlFor={"solution-detail-editor"}>
            {STRINGS_DISPLAYED.solution_details_label}
          </Label>
        </Row>
        <Row>
          <Text fontSize={"12px"} color={"grey"}>{STRINGS_DISPLAYED.required_string}</Text>
        </Row>
      </Col>
    }

    <SolutionDetailsRenderer actionType={actionType}/>
  </Col>;
}
